import React, { useEffect, useState } from 'react'
import Loader from '../Layout/Loader'
import DatePicker from "react-datepicker"
import mainAxios from '../../services/mainAxios'
import { useAppContext, usePersistedState } from '../../AppContext'
import useStateWithCallback from '../../services/useStateWithCallback'
import selectStyle, { customStyles } from "../../design/selectStyle";
import { useTranslation, withTranslation } from "react-i18next";
import PrimeTable from '../PrimeTable/PrimeTable'
import DateRange from '../global/DateRange'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import * as xlsx from 'xlsx';
import { useExportData } from '../global/hooks/useExportData'
import ExportCsvPrime from '../global/ExportCsvPrime'
import { defaultTableRows } from '../../services/data'
import CellInput, { CellTextarea } from '../global/CellInput'
import ReactSelectPagination from '../global/ReactSelectPagination'



const moment = require("moment")

const InvoiceLogs = ({visibility}) => {
    const { selectedCompany: [selectedCompany,],user:[user],company:[fullCompany] } = useAppContext()
    const [report,setReport]=useState({open:false,value:"1 minutes"})
    const [expandedRows, setExpandedRows] = React.useState([])
    const { t, i18n } = useTranslation('translations');
    const [invoicesForCSV, setInvoicesForCSV] = useState([]);

    const defaultFilters = {
        fromDate: new Date(),
        toDate: new Date(),
        params: {}
    };
    const [filters, setFilters] = React.useState(defaultFilters);

    const [companyFilterParams, setCompanyFilterParams] = useState({
        companyId: selectedCompany ?? null,
        isLoadingCompanies:false,
        companies:[]
    })

      const [companiesPagination,setCompaniesPagination]=useState({
        totalRows: 0,
        pageSize: 10,
        pageNumber: 1,
      })

    const [persistedRowPerPage, setPersistedRowPerPage,] = usePersistedState(
        10,
        "rowsPerPage"
    );

    const defaultSortCriteria={
        field: "recordDate",
        direction: "DESC"
    }

    const [tableRows, setTableRows] = useState({
        ...defaultTableRows,
        rowsPerPage:persistedRowPerPage,
        sortCriteria:defaultSortCriteria

    });
    const [searchQuery, setSearchQuery] = useState("");

    const [state, setState] = useStateWithCallback({
        logs: null,
        auditActions: [],
        auditObjects:[],
        loading: false
    })
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        mainAxios.post('apiEndpoint/search', {
            object: "GetAuditActions",
            value: null
        }).then(res => {

            if  (res?.data?.status === true) {
                const mappedContent=res.data.content.map(data=>{
                    return {
                        value:data.displayName,
                        label:data.displayName,
                    }
                })
                setState(state => ({  ...state, auditActions: mappedContent }))
            }
        })

        mainAxios.post('apiEndpoint/search', {
            object: "GetAuditObjects",
            value: null
        }).then(res => {
            if  (res?.data?.status === true) {
                const mappedContent=res.data.content.map(data=>{
                    return {
                        value:data.displayName,
                        label:data.displayName,
                    }
                })
                setState(state => ({  ...state, auditObjects: mappedContent  }))
            }
        })

    }, [companyFilterParams.companyId])

    React.useEffect(() => {
        getFilteredResults({})
    }, [companyFilterParams.companyId])

    const getFilteredResults = ({
        pageSize = persistedRowPerPage ?? defaultTableRows.rowsPerPage,
        page = defaultTableRows.currentPage,
        sortCriteria = [ defaultSortCriteria ],
        getLogsForCsv = false,
        updatedFilters = filters,
        fromDate = defaultFilters.fromDate,
        toDate = defaultFilters.toDate
    } = {}) => {

        setLoading(true);
        if (invoicesForCSV.length > 0) setInvoicesForCSV([]);
        return mainAxios.post("apiEndpoint/search", {
            object: "GetLogs",
            value: null,
            fromDate,
            toDate,
            params: {
                ...updatedFilters.params
            },
            pagination: getLogsForCsv ? null : {
                pageSize,
                pageNumber: page,
            },
            sortCriteria,
            company:companyFilterParams?.companyId?.toString()
        }).then((res) => {
            setLoading(false);
            if (res.data.status) {
                if (getLogsForCsv) {
                    setInvoicesForCSV(res.data.content);
                } else {
                    setTableRows((tableRows) => ({
                        ...tableRows,
                        totalRows: res.data.totalSize,
                    }));
                    setState((state) => ({ ...state, logs: res.data.content }));
                }
                return true;
            }else{
                setTableRows(defaultTableRows);
                setState((state) => ({ ...state, logs:[]}));
            }

            return false;
        }).catch(error => {
            setLoading(false);
            return false;
        });
    };


    const getCompaniesResults = ({pageSize=10, pageNumber = 1,searchQuery,loadMore}={}) => {
    let requestBody = {
        object: "GetSimpleCompany",
        value: null,
        companyFilterParams: {
            companyLiveSearch:searchQuery,
            // ...filters
        },
        pagination:{
            pageSize,
            pageNumber,
        },
        };
    return mainAxios.post('apiEndpoint/search',
    requestBody
    ).then(res => {
        if(res?.data?.status === true) {
            let companies = res.data.content
            setCompaniesPagination({
                pageNumber,
                pageSize,
                totalRows: res?.data?.totalSize,
            })
            setCompanyFilterParams((companyFilterParams)=>({...companyFilterParams,companies:loadMore?(companyFilterParams.companies ?? []).concat(companies):companies}))
        return companies
        }
        return []
    })
    .catch(err=>{
        return []
    })
    }

    const handleCompanyChange=(value)=>{
      setCompanyFilterParams(companyFilterParams=>({
        ...companyFilterParams,
        companyId:value?.id ?? selectedCompany,
        searchQuery:null,
      }))
      if(value===null){
        getCompaniesResults({pageNumber:1,pageSize:10,searchQuery:""})
      }

    }


    useEffect(()=>{
        getCompaniesResults({pageNumber:1,pageSize:10})
    },[])

    const companiesOptions=companyFilterParams.companies ?? []
    const headerButtonsLeft= (
        <div className='d-flex align-items-center gap-2'>
            {user?.role?.id===1 && (
                <div style={{width:250}}>
                <ReactSelectPagination
                    styles={customStyles}
                    value={companiesOptions.find(company => company.id == companyFilterParams?.companyId )}
                    options={companiesOptions}
                    onChange={handleCompanyChange}
                    placeholder={fullCompany?.name}
                    getOptionLabel={(option)=>option.name}
                    getOptionValue={(option)=>option.id}
                    getFilteredResults={getCompaniesResults}
                    pagination={companiesPagination}
                    setPagination={setCompaniesPagination}
                    isClearable={companyFilterParams?.companyId==selectedCompany?false: true}
                />
                </div>
            )}
            <div
                className="prime-table-toolbar__secondary-btn"
                onClick={() => { setReport((state) => ({ ...state, open: true })) }}
            >
                <FontAwesomeIcon icon={faDownload} />
                {t("logs.performanceReport")}
            </div>
        </div>
    )

    const type = [
        { value: "error", name: "Error" },
        { value: "success", name: "Success" },
        { value: "process", name: "Process" },
    ]
    const entity = [
        { value: "invoices", name: t("navbar.invoices") },
        { value: "wtn", name: "WTN" },
        { value: "cashOperation", name: "Cash Operation" },
        { value: "companySettings", name: "Company Settings" },
        { value: "bu", name: "BU" },
        { value: "tcr", name: "TCR" },
        { value: "contacts", name: "Contacts" },
        { value: "items", name: t("navbar.products")  },
    ]
    const source = [
        { value: "api", name: "API" },
        // { value: "agent", name: "Agent" },
        { value: "manual", name: "Manual" },
        { value: "schedulerResend ", name: "Scheduler Resend " },
        // { value: "schedulerNotif", name: "Scheduler Notification " },
        { value: "schedulerGetInvoices ", name: "Scheduler Get Invoices " },
    ]
    const menu = [
        { value: "myPos", name: "My POS" },
        { value: "advancedSendAndReceive", name: "Advanced Send And Receive"},
        { value: "fiscalizedInvoices", name: "Fiscalized Invoices" },
        { value: "createInvoices", name: "Create Invoices" },
        { value: "getInvoicesScheduler", name: "Get Invoices Scheduler" },
        { value: "eventScheduler", name: "Event Scheduler" },
        { value: "uploadV1", name: "Upload/V1" },
        { value: "uploadV2", name: "Upload/V2" },
        { value: "scheduler", name: "Scheduler" },
        { value: "settingsBranches", name: "Settings/Branches" },
        { value: "settingsTCR", name: "Settings/TCR" },
        { value: "wtn ", name: "WTN" },
        { value: "search", name: "Search" },
        { value: "myBook  ", name: "My Book" },
    ]

    const columns = [
        // {
        //     expander: true,
        //     field:"expand",
        //     frozen: true,
        //     style: { minWidth: "8px", maxWidth: "8px" },
        // },
        {
            header: t(['logs.action']),
            field: 'auditActions.displayName',
            // style: { minWidth: "140px", maxWidth: "150px" },
            default:true,
            mobile: { priority: 1, isTitle: true, group: "identity" },
            filterType: "DROPDOWN",
            filterConfig: {
                options: state?.auditActions ?? [],
                optionLabel: "label",
                optionValue: "value",
                splitKey: false,
                panelStyle:{
                    maxWidth:350
                }
            },
            // body: (log) => <CellInput value={log?.auditActions?.displayName?? ""} />,
            format: (log) => log?.auditActions?.displayName,
            filter: true,
        },
        {
            header: t(['logs.object']),
            field: 'auditObject.displayName',
            default:true,
            mobile: { priority: 1, group: "identity" },
            filterType: "DROPDOWN",
            filterConfig: {
                options: state?.auditObjects ?? [],
                optionLabel: "label",
                optionValue: "value",
                splitKey: false,
                panelStyle:{
                    maxWidth:350
                }
            },
            format: (invoice) => invoice?.auditObject?.displayName,
            // body: (object) => <CellTextarea width={140} value={object?.auditObject?.displayName ?? ""} onFocus={(event) => event.target.select()} />,

            filter: true,
        },
        {
            header: t(['subscription.type']),
            field: 'type',
            default:true,
            mobile: { priority: 1, isBadge: true, group: "status" },
            style: { minWidth: "150px", maxWidth: "150px" },
            filterType: "DROPDOWN",
            filterConfig: {
                options: type,
                optionLabel: "name",
                optionValue: "value",
            },
            filter: true,
        },
        {
            header: t(['common.source']),
            field: 'source',
            default:true,
            mobile: { priority: 1, group: "details" },
            style: { minWidth: "170px", maxWidth: "170px" },
            filterType: "DROPDOWN",
            filterConfig: {
                options: source,
                optionLabel: "name",
                optionValue: "value",
            },
            filter: true,
        },
        {
            header: t(['home.date']),
            field: 'recordDate',
            default:true,
            mobile: { priority: 1, group: "dates" },
            formattedExportValue: true,
            preventExcelFormat: true,
            filterType: "DATE",
            filterConfig: {
                field: "invoiceDate"
            },
            body: log => log.recordDate ? moment(log.recordDate).format("DD/MM/YYYY HH:mm") : "",
            style: { minWidth: "190px", maxWidth: "190px" },
            filter: true,
            sortable: false
        },
        {
            header: t(['logs.user']),
            field: 'recordUser',
            default:true,
            mobile: { priority: 1, group: "identity" },
            filter:true,
            body: log => log.recordUser ? log.recordUser : "",
            style: { minWidth: "140px", maxWidth: "140px" },
        },
        {
            header: t(['table.errorCode']),
            field: 'errorCode',
            default:true,
            mobile: { priority: 1, group: "details" },
            filter:true,
            body: log => log.errorCode ? log.errorCode : "",
            style: { minWidth: "140px", maxWidth: "140px" },
        },
        {
            header: "NIVF/NIVFSH",
            field: 'fic',
            default:true,
            mobile: { priority: 1, group: "reference" },
            filter:true,
            // body: (action) => <CellTextarea width={180} value={action?.fic?? ""} onFocus={(event) => event.target.select()} />,
            body: (log) => <CellInput value={log?.fic ?? ""} width={180} />,
        },
        {
            header: "NSLF/NSLFSH",
            field: 'iic',
            default:true,
            mobile: { priority: 1, group: "reference" },
            filter:true,
            body: (log) => <CellInput value={log?.iic ?? ""} width={180} />,
            // body: (action) => <CellTextarea width={180} value={action?.iic?? ""} onFocus={(event) => event.target.select()} />,
            // style: { minWidth: "180px", maxWidth: "180px" },
        },
        {
            header: t("purchases.bussinesCode"),
            field: 'branchId',
            default:true,
            mobile: { priority: 1, group: "reference" },
            filter:true,
            body: log => log?.branchId ?? "" ,
            style: { minWidth: "150px", maxWidth: "150px" },
        },
        {
            header: "ERP ID",
            field: 'erpId',
            default:true,
            filter:true,
            body: (log) => <CellInput value={log?.erpId ?? ""} width={180} />,
            // style: { minWidth: "150px", maxWidth: "150px" },
        },
        {
            header: t(['navbar.notifications']),
            field: 'notification',
            default: false,
            filter: true,
            filterType: "TRISTATECHECKBOX",
            dataType: "boolean",
            body: log => log.notification ? log.notification : "",
            style: { minWidth: "120px", maxWidth: "120px" },
        },
        {
            header: t(['logs.notificationStatus']),
            field: 'notifStatus',
            default: false,
            filter: true,
            filterType: "TRISTATECHECKBOX",
            dataType: "boolean",
            body: log => log.notifStatus ? log.notifStatus : "",
            style: { minWidth: "210px", maxWidth: "210px" },
        },
        {
            header: t(['company.operatorCode']),
            field: 'opcode',
            default:true,
            filter:true,
            body: log => log.opcode ? log.opcode : "",
            style: { minWidth: "150px", maxWidth: "150px" },
        },
        {
            header: "Menu",
            field: 'menu',
            default:false,
            filterType: "DROPDOWN",
            filterConfig: {
                options: menu,
                optionLabel: "name",
                optionValue: "value",
            },
            filter:true,
            body: log => log.menu ? log.menu : "",
            style: { minWidth: "150px", maxWidth: "200px" },
        },
        {
            header: t(['logs.entity']),
            field: 'entity',
            filterType: "DROPDOWN",
            filterConfig: {
                options: entity,
                optionLabel: "name",
                optionValue: "value",
            },
            filter:true,
            body: log => log.entity ? log.entity : "",
            style: { minWidth: "150px", maxWidth: "150px" },
        },
        {
            header: t(['customers.company']),
            field: 'company',
            filter:true,
            sortable: true,
            body: log => log.company ? log.company : "",
            style: { minWidth: "150px", maxWidth: "150px" },
        },
        {
            header: 'Info',
            field: 'logInfo',
            filter: true,
            // style: { minWidth: "180px", maxWidth: "180px" },
            body: (log) => <CellTextarea width={190} value={log?.logInfo ?? ""} onFocus={(event) => event.target.select()} />,

        }
    ];


    const [selectedColumns, setSelectedColumns] = usePersistedState(
        columns.map((col) => ({ field: col.field, show: !!col.default, ...(col?.persisted ? { persisted: true } : {}) })),
        "logsColumns"
    );

    const expandableColumns = [
        {
            header: t(['logs.action']),
            field: 'auditActions.displayName'
        },
        {
            header: t(['logs.object']),
            field: 'auditObject.displayName'
        },
        {
            header: t(['Info']),
            field: 'logInfo'
        }
    ]

    const rowExpansionTemplate = (e) => {
        return (
            <div className='prime-header-sticky' style={{ marginBottom: 20 }}>
                <PrimeTable
                    value={expandedRows}
                    columns={expandableColumns}
                    simpleTable={true}
                    showFilters={false}
                    paginator={false}
                    filterDisplay={false}
                    responsiveLayout="scroll"
                />
            </div>
        )
    }


    const reportInterval=[
        {
            label:"1 minute",
            value:"1 minutes"
        },
        {
            label:"5 minuta",
            value:"5 minutes"
        },
        {
            label:"10 minuta",
            value:"10 minutes"
        },
        {
            label:"1 ore",
            value:"1 hours"
        },
        {
            label:"3 ore",
            value:"3 hours"
        },
        {
            label:"12 ore",
            value:"12 hours"
        },
        {
            label:"24 ore",
            value:"24 hours"
        },
        {
            label:"48 ore",
            value:"48 hours"
        },
        {
            label:"72 ore",
            value:"72 hours"
        },
    ]

    const downloadReportRequest = () => {
        return mainAxios.post("/reports/v1", {
            value: report.value,
            nuis: user.companiesRights.find(
                (company) => company.id === parseInt(selectedCompany)
            )?.nuis,
            fromDate: filters.fromDate,
            toDate: filters.toDate
        })
        .then(res => {
            if (res.data.status && res?.data?.content?.length > 0) {
                return res.data.content;
            }
            return null;
        })
        .catch(err => {
            return null;
        });
    };

    const { exportData, loadingExport } = useExportData({ fetchFunc: downloadReportRequest });

    const handleExportAndClose = () => {
        getFilteredResults({ getLogsForCsv: true, fromDate: filters.fromDate, toDate: filters.toDate }).then(() => {
            exportData();
            setReport((state) => ({ ...state, open: false }));
        });
    };

    const headerIcons = (
        <div className='d-flex align-items-center gap-2'>
            <DateRange
                size="sm"
                fromDate={filters.fromDate}
                toDate={filters.toDate}
                onChange={(dates) => {
                    const [fromDate, toDate] = dates;
                    if (fromDate && toDate) {
                        getFilteredResults({ fromDate, toDate });
                    }
                    setFilters((filters) => ({
                        ...filters,
                        fromDate,
                        toDate,
                    }));
                }}
            />
            <ExportCsvPrime
                selectedColumns={selectedColumns}
                iconOnly
                tooltip="Export CSV"
                data={invoicesForCSV}
                columns={columns}
                onClick={() => getFilteredResults({ getLogsForCsv: true, fromDate: filters.fromDate, toDate: filters.toDate })}
                excludedColumns={["expand"]}
            />
        </div>
    )

    const downloadReport = (
        <>
            <Dialog
                header={t("logs.performanceReport")}
                visible={report?.open}
                onHide={() => { setReport((state) => ({ ...state, open: false, })) }}
                style={{ width: "20vw", height: "28vh", zIndex: 1000 }}
                breakpoints={{ "960px": "75vw", "641px": "100vw" }}

            >

                {
                    report?.open && (
                        <>
                            <div className='d-flex justify-content-center align-items-center h-full'>

                                <div className='d-flex align-items-end gap-2' style={{ width: 300 }}>
                                    <div>
                                        <label>{t("logs.chooseIntervalInterval")}</label>
                                        <Dropdown value={report.value}
                                            className='w-full'
                                            onChange={(e) => setReport(state => ({ ...state, value: e.value }))}
                                            options={reportInterval} optionLabel="label"
                                            optionValue="value" />
                                    </div>
                                    <button className='btn btn-primary' disabled={loadingExport}  onClick={handleExportAndClose}>
                                        Shkarko
                                    </button>
                                </div>


                            </div>
                        </>
                    )
                }
            </Dialog>
        </>
    )
    return (
        state.logs ?
            <>
                {downloadReport}
                <PrimeTable
                        loading={loading}
                        columns={columns}
                        value={[...state.logs]}
                        showFilters={true}
                        rowExpansionTemplate={rowExpansionTemplate}
                        globalFilterValue={[searchQuery, setSearchQuery]}
                        tableRows={[tableRows, setTableRows]}
                        clearFilters={true}
                        showSelectColumns
                        gridKey="logsColumns"
                        selectedColumns={[selectedColumns, setSelectedColumns]}
                        reorderableColumns={true}
                        onRowToggle={(e) => setExpandedRows(e.data)}
                        persistedRowPerPage={[persistedRowPerPage, setPersistedRowPerPage]}
                        filters={[filters, setFilters]}
                        defaultFilters={defaultFilters}
                        expandedRows={expandedRows}
                        defaultSortCriteria={defaultSortCriteria}
                        headerButtonsLeft={headerButtonsLeft}
                        headerIcons={headerIcons}
                        onRemoteDataChange={(remoteData) => {
                            const updatedFilters = remoteData.filters ?? filters;
                            const updatedTableData = remoteData.tableRows ?? tableRows;
                            let { currentPage, rowsPerPage, sortCriteria } = updatedTableData;
                            sortCriteria = sortCriteria ? [sortCriteria] : [];
                            getFilteredResults({
                                updatedFilters,
                                pageSize: rowsPerPage,
                                page: currentPage,
                                sortCriteria,
                                fromDate: updatedFilters.fromDate,
                                toDate: updatedFilters.toDate
                            });
                        }}
                        columnDeps={[companyFilterParams.companyId]}
                    />
            </>
            :
            <Loader />
    )
}

export default InvoiceLogs
